import type { ErpIntermediateMetadata } from '@vy/types';
import { isEmptyArray, isEmptyString, isNullOrUndefined } from '@vy/utils';
import { useMemo } from 'react';
import { WIZARD_STEPS, type WizardStep } from '../types';

type UseNetSuiteSyncWizardStepParams = {
  currentStep: WizardStep;
  isLastStep: boolean;
  isSynced: boolean;
  selectedCustomer: ErpIntermediateMetadata | null;
  selectedProductsIds: string[];
  selectedSubsidiary: string;
};

export function useNetSuiteSyncWizardStep({
  currentStep,
  isLastStep,
  isSynced,
  selectedCustomer,
  selectedProductsIds,
  selectedSubsidiary,
}: UseNetSuiteSyncWizardStepParams) {
  const isNextDisabled = useMemo(() => {
    switch (currentStep) {
      case WIZARD_STEPS.CUSTOMER_CONNECTION:
        return isNullOrUndefined(selectedCustomer);

      case WIZARD_STEPS.PRODUCT_SELECTION:
        return isEmptyArray(selectedProductsIds);

      case WIZARD_STEPS.SUBSIDIARY_AND_MEMO:
        return isEmptyString(selectedSubsidiary);

      default:
        return false;
    }
  }, [currentStep, selectedCustomer, selectedProductsIds, selectedSubsidiary]);

  const ctaText = useMemo(() => {
    if (isLastStep) {
      return isSynced ? 'Update order' : 'Sync Order';
    }

    return 'Next';
  }, [isLastStep, isSynced]);

  return {
    isNextDisabled,
    ctaText,
  };
}

